import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserData } from '@/shared/types/UserData';
import { useErrorHandler } from '@/shared/hooks/useErrorHandler';
import { useAuth } from '@/contexts/auth.context';

import { useAlertContext } from '@/contexts/alert.context';
import { providerUserService } from '@/services/providerUser.service';

export type CreateProviderData = UserData & {
  roles: string[];
};

export function useProviderUserRegister() {
  const { handleError } = useErrorHandler();
  const { user } = useAuth();
  const navigation = useNavigate();
  const { notify } = useAlertContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (data: CreateProviderData) => {
    setIsSubmitting(true);
    try {
      if (!user?.providerId) {
        throw new Error('Usuário não possui uma prestadora vinculada');
      }

      await providerUserService.createProviderUser({
        name: data.name,
        email: data.email,
        roleIds: data.roles,
        phoneNumber: data.phone,
        providerId: user.providerId,
      });

      notify({ message: `Usuário ${data.name} criado com sucesso!`, type: 'success' });

      navigation('/provider-list');
    } catch (error) {
      handleError(error, 'Error ao criar usuário.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    onSubmit,
    isSubmitting,
  };
}
